import template from './ecocode-trustpilot-sales-channel.html.twig';

Shopware.Component.register('ecocode-trustpilot-sales-channel', {
    template,
    methods: {
        async sendInvitation() {
            await this.$refs.invitation.inviteAction();
        }
    },
    props: {
        salesChannel: {
            required: true
        }
    }
});
